import { isEmpty } from 'lodash';

import { COUNTRY_INDIA } from '@utils/constants';

import { getProductDetails, useTermQuoteStore } from './termquote';

const getIsHealthQuote = () =>
  window.location.pathname.includes('health/fq') ||
  window.location.pathname.includes('health/quote');

const getIsTermQuote = () =>
  window.location.pathname.includes('term/fq') ||
  window.location.pathname.includes('term/quote');

/*
Checks if the current quote is for an NRI.

Health products are not available for NRIs.
For Term products returns true if the NRI is enabled for the current product and if the user is an NRI.
*/
export const useIsNRIQuote = () => {
  const plan = useTermQuoteStore((state) => state.plan);
  const isHealthQuote = getIsHealthQuote();
  const isTermQuote = getIsTermQuote();

  // Health Quote is not available for NRIs
  if (isHealthQuote) return false;

  if (isTermQuote) {
    const isNRIEnabled = getProductDetails(plan.product)?.boundaries?.isNRIEnabled;
    if (!isNRIEnabled) return false;

    const isNRI = plan.isNRI;

    return isNRI;
  }

  return false;
};

/*

Currently Max Life NRI quote journey restricts the user to select only the country code of the country they are currently in.

*/
export const useAllowedCountriesForLogin = () => {
  const { isNRI, nriCountry, product } = useTermQuoteStore((state) => ({
    nriCountry: state.plan.nriCountry,
    isNRI: state.plan.isNRI,
    product: state.plan.product
  }));

  const isHealthQuote = getIsHealthQuote();
  // Health Quote is not available for NRIs
  if (isHealthQuote) return [];
  const isTermQuote = getIsTermQuote();

  if (!isTermQuote) return [];

  const selectedProductBoundaries = getProductDetails(product)?.boundaries;

  if (isEmpty(selectedProductBoundaries)) {
    return [];
  }

  if (!isNRI) {
    // Restrict to India if NRI is not selected.
    return [COUNTRY_INDIA.name];
  }

  // Restrict to the country selected by the user and India
  if (selectedProductBoundaries?.shouldRestrictLoginPhone) {
    const nriCountryCode = selectedProductBoundaries?.countries?.find(
      (country) => country.name === nriCountry
    );

    if (nriCountryCode) {
      return [nriCountryCode.name, COUNTRY_INDIA.name];
    }

    return [COUNTRY_INDIA.name];
  }

  return [];
};
